import { getNbaPlayerPath } from "../../adapters/nbaPlayerAdapter";

const PCT_METRICS = new Set([
  "trueShootingPct",
  "turnoverPct",
  "threePointAttemptRate",
  "freeThrowRate",
  "completionPct",
]);

export const SIMILAR_SEASONS_ANCHOR = "similar-seasons";

const LEAGUE_PATHS = {
  nba: (playerId, season) => {
    const path = getNbaPlayerPath(playerId);
    if (!path || !season) return path;
    return `${path}?season=${encodeURIComponent(season)}#${SIMILAR_SEASONS_ANCHOR}`;
  },
  mlb: (playerId, season, { role } = {}) => {
    const path = `/app/player/${encodeURIComponent(playerId)}`;
    if (!season || !role) return null;
    const params = new URLSearchParams({
      season: String(season),
      role: String(role),
    });
    return `${path}?${params}#${SIMILAR_SEASONS_ANCHOR}`;
  },
  nfl: (playerId, season, { role } = {}) => {
    const path = `/app/nfl/player/${encodeURIComponent(playerId)}`;
    if (!season || !role) return null;
    const params = new URLSearchParams({
      season: String(season),
      role: String(role),
    });
    return `${path}?${params}#${SIMILAR_SEASONS_ANCHOR}`;
  },
};

export function getSimilarSeasonPath(league, playerId, season, options) {
  const buildPath = LEAGUE_PATHS[league];
  if (!buildPath || !playerId) return null;
  return buildPath(playerId, season, options);
}

export function similarityPercent(score) {
  if (score == null || !Number.isFinite(Number(score))) return null;
  return Math.round(Number(score) * 100);
}

export function formatSimilarityScore(score) {
  const percent = similarityPercent(score);
  return percent == null ? "" : `${percent}%`;
}

export function formatSimilarityStat(metric, value) {
  if (value == null || !Number.isFinite(Number(value))) return "—";
  const amount = Number(value);
  if (metric === "age") return String(Math.round(amount));
  if (PCT_METRICS.has(metric)) return `${(amount * 100).toFixed(1)}%`;
  return amount.toFixed(1);
}
